export interface AppealAddDocType {
  url: string;
  type: string;
  name: string;
}

export const EMPTY_APPEAL_ADD_DOC: AppealAddDocType = {
  url: '',
  name: '',
  type: '',
};

export const APPEAL_DOC_ID = '001';
